export default __webpack_public_path__ + "static/sm-poster-03-dee2ce86c68c43a536123dc536c71cd0.png";